<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="py-5">
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Monthly Sales Report
                    <div class="month-label">{{ formatDate(date) }} Report</div>
                  </v-toolbar-title>
                </div>
                <div class="ml-auto d-flex">
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="date"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="primary" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-calendar</v-icon> Choose Month
                      </v-btn>
                    </template>
                    <v-date-picker v-model="date" type="month" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modal = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                  <v-select
                    :items="cities"
                    label="Select City"
                    dense
                    class="ml-2 mt-2"
                    v-model="currentCity"
                  ></v-select>
                </div>
              </div>
            </v-col>
            <!-- <v-spacer></v-spacer> -->
          </v-toolbar>

          <!-- <v-divider></v-divider> -->
        </v-card>
      </v-col>

      <v-col cols="12" md="4" lg="4">
        <PieChart
          :chartOptions="charts.days.chartOptions"
          chartTitle="Days"
          :chartWidth="480"
          :chartSeries="charts.days.series"
        >
        </PieChart>
      </v-col>

      <v-col cols="12" md="4" lg="4">
        <PieChart
          :chartOptions="charts.gadgets.chartOptions"
          chartTitle="Per Gadgets"
          :chartWidth="480"
          :chartSeries="charts.gadgets.series"
        >
        </PieChart>
      </v-col>

      <v-col cols="12" md="4" lg="4">
        <PieChart
          :chartOptions="charts.sku.chartOptions"
          chartTitle="Per SKU"
          :chartWidth="480"
          :chartSeries="charts.sku.series"
        >
        </PieChart>
      </v-col>

      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Monthly Sales per Channel
                  </v-toolbar-title>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>
          <v-data-table
            :headers="table.channel.headers"
            :items="table.channel.data"
            :loading="table.channel.loading"
            item-key="id"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <!-- <template v-slot:[`item.total`]="{ item }">
              {{ item.total.toLocaleString() }}
            </template>

            <template v-slot:[`item.retailer`]="{ item }">
              {{ item.retailer.toLocaleString() }}
            </template> -->

            <template
              v-for="header in table.channel.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <!-- <template v-slot:[`item.gcash`]="{ item }">
              {{ item.gcash ? item.gcash : "--" }}
            </template> -->
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Monthly Sales per Location
                  </v-toolbar-title>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>
          <v-data-table
            :headers="table.location.headers"
            :items="table.location.data"
            :loading="table.location.loading"
            item-key="id"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template v-slot:[`item.retailer`]="{ item }">
              {{ item.retailer.toLocaleString() }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Monthly Sales per SKU
                  </v-toolbar-title>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>
          <v-data-table
            :headers="table.sku.headers"
            :items="table.sku.data"
            :loading="table.sku.loading"
            item-key="id"
            loading-text="Loading... Please wait"
            class="elevation-1"
            >]
            <template
              v-for="header in table.sku.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
            <!-- <template v-slot:[`item.price`]="{ item }">
              {{ item.price ? item.price.toLocaleString() : "" }}
            </template> -->
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import PieChart from "../acquisition/components/PieChart.vue";
import ShareableMethods from "@/mixins/ShareableMethods";

export default {
  name: "MonthlySalesReport",
  components: {
    PieChart,
  },
  mixins: [ShareableMethods],
  data() {
    return {
      charts: {
        days: {
          series: [],
          chartOptions: {
            labels: [],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                },
              },
            ],
            legend: {
              position: "bottom",
            },
            noData: {
              text: "Loading...",
            },
            tooltip: {
              y: {
                formatter: function(value) {
                  return value.toLocaleString();
                },
              },
            },
          },
        },
        gadgets: {
          series: [],
          chartOptions: {
            labels: [],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  // legend: {
                  //   position: "bottom",
                  // },
                },
              },
            ],
            legend: {
              position: "bottom",
            },
            noData: {
              text: "Loading...",
            },
            tooltip: {
              y: {
                formatter: function(value) {
                  return value.toLocaleString();
                },
              },
            },
            // plotOptions: {
            //   pie: {
            //     dataLabels: {
            //       minAngleToShowLabel: 15,
            //     },
            //   },
            // },
          },
        },
        sku: {
          series: [],
          chartOptions: {
            labels: [],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 300,
                  },
                  // legend: {
                  //   position: "top",
                  // },
                },
              },
            ],
            legend: {
              position: "bottom",
            },
            noData: {
              text: "Loading...",
            },
            tooltip: {
              y: {
                formatter: function(value) {
                  return value.toLocaleString();
                },
              },
            },
          },
        },
      },

      currentCity: "All",
      cities: ["All"],
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,

      table: {
        channel: {
          loading: false,
          headers: [
            {
              text: "Paymaya",
              sortable: false,
              value: "paymaya",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "Gcash",
              sortable: false,
              value: "gcash",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "WechatPay",
              sortable: false,
              value: "wechat",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "Credit/Debit Card",
              sortable: false,
              value: "card",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "BPI",
              sortable: false,
              value: "bpi",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "Alipay",
              sortable: false,
              value: "alipay",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "Retailer",
              sortable: false,
              value: "retailer",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "Sign-up / Install",
              sortable: false,
              value: "signupInstall",
              formatter: (x) => this.setToLocaleString(x),
            },

            {
              text: "Voucher",
              sortable: false,
              value: "voucher",
              formatter: (x) => this.setToLocaleString(x),
            },

            {
              text: "Total",
              sortable: false,
              value: "total",
              formatter: (x) => this.setToLocaleString(x),
            },
          ],
          data: [],
        },

        location: {
          loading: false,
          headers: [
            {
              text: "Location",
              sortable: false,
              value: "city",
            },
            // {
            //   text: "Paymaya",
            //   sortable: false,
            //   value: "paymaya",
            // },
            // {
            //   text: "Gcash",
            //   sortable: false,
            //   value: "gcash",
            // },
            {
              text: "Retailer",
              sortable: false,
              value: "retailer",
            },
          ],
          data: [],
        },

        sku: {
          loading: false,
          headers: [
            {
              text: "SKU",
              sortable: false,
              value: "sku",
            },
            {
              text: "Quantity",
              sortable: false,
              value: "quantity",
              align: "center",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "Price",
              sortable: false,
              value: "price",
              formatter: (x) => this.setToLocaleString(x),
            },
            {
              text: "Total",
              sortable: false,
              value: "total",
              formatter: (x) => this.setToLocaleString(x),
            },
          ],
          data: [],
        },
      },
    };
  },

  methods: {
    async getList() {
      this.table.channel.loading = true;
      this.table.location.loading = true;
      this.table.sku.loading = true;

      const startOfMonth = moment(this.date)
        .startOf("month")
        .format("YYYY-MM-DD");
      const endOfMonth = moment(this.date)
        .endOf("month")
        .format("YYYY-MM-DD");
      await this.$api
        .get(
          `/acquisition/report?report=monthlySalesReport&startDate=${startOfMonth}&endDate=${endOfMonth}&city=${
            this.currentCity == "All" ? "" : this.currentCity
          }`
        )
        .then((response) => {
          const newArr = response.data.data;
          this.table.channel.data = [newArr.channel];
          this.table.channel.loading = false;
          console.log([newArr.channel]);

          this.table.location.data = newArr.location;
          this.table.location.loading = false;

          this.table.sku.data = newArr.sku;
          newArr.cities.forEach((city) => {
            this.cities.push(city);
          });
          this.table.sku.loading = false;
        })
        .catch((e) => {
          this.table.channel.loading = false;
          this.table.location.loading = false;
          this.table.sku.loading = false;

          console.log(e);
        });
    },

    async getChartData() {
      this.table.loading = true;
      // const startOfMonth = moment(this.date)
      //   .startOf("month")
      //   .format("YYYY-MM-DD");
      // const endOfMonth = moment(this.date)
      //   .endOf("month")
      //   .format("YYYY-MM-DD");

      //   console.log(startOfMonth, endOfMonth, this.currentCity)
      await this.$api
        .get("/acquisition/report?report=monthlyPieChart")
        .then((response) => {
          const newArr = response.data.data;

          // this.charts.days.series = [];
          // this.charts.days.chartOptions.labels = [];
          newArr.days.map((val) => {
            this.charts.days.series.push(val.value);
            this.charts.days.chartOptions.labels.push(val.label);
          });

          // // this.charts.gadgets.series = [];
          // // this.charts.gadgets.chartOptions.labels = [];
          newArr.gadgets.map((val) => {
            this.charts.gadgets.series.push(val.value);
            this.charts.gadgets.chartOptions.labels.push(val.label);
          });

          // // this.charts.sku.series = [];
          // // this.charts.sku.chartOptions.labels = [];
          newArr.sku.map((val) => {
            this.charts.sku.series.push(val.value);
            this.charts.sku.chartOptions.labels.push(val.label);
          });
        })
        .catch((e) => {
          // this.table.loading = false;
          console.log(e);
        });
    },

    formatDate(d) {
      return moment(d).format("MMMM YYYY");
    },
  },
  created() {
    this.getList();
    this.getChartData();
    // console.log(this.$props.headers);
  },

  watch: {
    date() {
      this.getList();
      // this.getChartData();
    },
    currentCity() {
      this.getList();
      // this.getChartData();
    },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scope>
.month-label {
  font-size: 0.9rem;
  color: #9e9e9e;
}
</style>
